import { createRouter, createWebHistory } from 'vue-router'
const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'home',
            redirect: '/overview',
        },
        {
            path: '/overview',
            name: 'Overview',
            component: () => import('../features/AdminHome.vue'),
        },
         {
            path: '/program/:id',
            name: 'program',
            component: () => import('@/features/program/pages/ProgramDetail.vue')
        },
         {
            path: '/trip/:id',
            name: 'trip',
            component: () => import('@/features/trip/pages/TripDetail.vue')
        },
         {
            path: '/traveler/:id',
            name: 'traveler',
            component: () => import('@/features/traveler/pages/TravelerProfile.vue')
        },
        {
            path: '/programtraveler/:id',
            name: 'programtraveler',
            component: () => import('@/features/program/pages/ProgramTripDetail.vue')
        },
        {
            path: '/programupdate/:id',
            name: 'programupdate',
            component: () => import('@/features/program/pages/ProgramUpdate.vue')
        },
         {
            path: '/addtraveler/:id',
            name: 'addtraveler',
            component: () => import('@/features/traveler/pages/AddTraveler.vue')
        },
         {
            path: '/projectdetails/:id',
            name: 'projectdetails',
            component: () => import('@/features/traveler/pages/ProjectDetails.vue')
        },
         {
            path: '/flightsearch/:id',
            name: 'flightsearch',
            component: () => import('@/features/program/pages/FlightSearch.vue')
        },
         {
            path: '/updateleg/:id',
            name: 'updateleg',
            component: () => import('@/features/trip/pages/UpdateLeg.vue')
        },
        {
            path: '/programupdatelegtravelers/:id',
            name: 'programupdatelegtravelers',
            component: () => import('@/features/program/pages/ProgramUpdateLegTravelers.vue')
        },
         {
            path: '/highriskcountries/:id',
            name: 'highriskcountries',
            component: () => import('@/features/highrisk/pages/HighRiskCountries.vue')
        },
         {
            path: '/updatehighriskcountry/:id',
            name: 'updatehighriskcountry',
            component: () => import('@/features/highrisk/pages/UpdateHighRiskCountry.vue')
        },
         {
            path: '/guests/:id',
            name: 'guests',
            component: () => import('@/features/guest-invite/pages/GuestsInviteOverview.vue')
        },
         {
            path: '/guest/:id',
            name: 'guest',
            component: () => import('@/features/guest-invite/pages/GuestInvitesOverview.vue')
        },
        {
            path: '/guestupdate/:id',
            name: 'guestupdate',
            component: () => import('@/features/guest-invite/pages/GuestInviteUpdate.vue')
        },
        {
            path: '/guestsearch/:id',
            name: 'guestsearch',
            component: () => import('@/features/guest-invite/pages/GuestSearch.vue')
        },
    ]

})

export default router
